import { Phone, Clock } from "lucide-react";
import { BUSINESS } from "@/data/business";

export default function CtaBanner() {
  return (
    <section className="relative bg-red-600 text-white py-16 lg:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-20" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-red-700 text-white px-3 py-1.5 rounded-sm text-xs font-bold uppercase tracking-widest mb-5">
          <Clock className="h-3.5 w-3.5" /> Available 24/7
        </div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-balance">
          Garage Door Broken? We'll Fix It Today.
        </h2>
        <p className="mt-4 text-lg text-red-50 max-w-2xl mx-auto">
          Call now for fast, same-day garage door repair in Prosper and across
          Collin County. Friendly local techs and upfront pricing.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            className="inline-flex items-center justify-center gap-2.5 bg-slate-900 hover:bg-slate-800 active:scale-[0.98] text-white font-bold text-lg px-8 py-4 rounded-sm transition-colors"
            data-testid="cta-call-button"
          >
            <Phone className="h-5 w-5" /> Call {BUSINESS.phoneDisplay}
          </a>
          <a
            href="#quote"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-red-50 text-slate-900 font-bold text-lg px-8 py-4 rounded-sm transition-colors"
            data-testid="cta-quote-button"
          >
            Request a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
